import * as constants from '../constants';

const mutations = {
  [constants.PAGE_PAGES]: (state, pages) => {
    state.pages = pages;
  },
};

export default mutations;
